<template>
  <b-modal id="geoCount"
           :title = "title"
           :lazy="true"
           @hidden = "hidden"
           @shown = "show"
           @ok="next"
           ok-title = "Next">

    <div>
      <b-form-radio-group v-model="isAllHoseholds"
                          stacked v-if="!hasDemoWithotAll">

        <div class="the-item">
          <b-form-radio :value="false" class="h3">{{phoneMessage}}</b-form-radio>
        </div>
        <div class="the-item">
          <b-form-radio :value="true" class="h3">{{hoseholds.SettingDesc}}</b-form-radio>
          <m-phone-option :disabled="!isAllHoseholds"
                          v-show="isAllHoseholds"
                          class="phone-option"
                          style="margin-top: 4px"/>
        </div>
      </b-form-radio-group>
      <m-phone-option v-if="hasDemoWithotAll" class="phone-option"/>
      <b-alert :show="alertDesc!==''" variant="warning" v-html="alertDesc" style="margin-top: 16px"></b-alert>
    </div>
  </b-modal>

</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MPhoneOption from '@/components/demo/MPhoneOption'

  export default {
    components: {
      MDemoAllCheck,
      MPhoneOption
    },
    created () {
    },
    data () {
      return {
        alertDesc: ''
      }
    },
    computed: {
      isBusiness () {
        return this.$store.getters['demo/isBusiness']
      },
      phoneMessage () {
        if (this.isBusiness) {
          return 'I’d like to build my audience using business types and demographic options.'
        } else {
          return 'I’d like to build my audience using your available demographic and psychographic filters.'
        }
      },
      isAllHoseholds: {
        get () {
          return this.$store.state.order.DemoType === 99
        },
        set (val) {
          if (val) {
            this.$store.commit('order/setAllHouseholds')
          } else {
            this.alertDesc = ''
            this.$store.commit('order/setUnAllHouseholds')
          }
        }
      },
      hoseholds () {
        return this.$store.state.demo.allHouseholdSetting || {}
      },
      hasPhoneOption () {
        return this.$store.getters['order/hasPhoneOption']
      },
      hasDemoWithotAll () {
        return this.$store.getters['order/hasDemoWithotAll']
      },
      title () {
        if (!this.hasDemoWithotAll) {
          return 'Who do you wish to target?'
        } else {
          return 'Please select a Phone Option'
        }
      },
      noPhoneOption () {
        return this.$store.getters['demo/noPhoneOption']
      }
    },
    methods: {
      next (evt) {
        evt.preventDefault()
        this.alertDesc = ''
        if (this.isAllHoseholds || this.hasDemoWithotAll) {
          if (!this.hasPhoneOption && !this.noPhoneOption) {
            this.alertDesc += 'Please select a Phone Option<br>'
            return false
          }
          this.$store.dispatch('order/submitOrder')
          this.$nextTick(() => {
            this.$root.$emit('bv::hide::modal', 'geoCount')
          })
        } else {
          this.$router.push({name: 'demo'})
          this.$nextTick(() => {
            this.$root.$emit('bv::hide::modal', 'geoCount')
          })
        }
      },
      show () {
        // if (!this.hasDemoWithotAll) {
        //   this.$store.commit('order/setAllHouseholds')
        // }
      },
      hidden () {
        this.$store.commit('order/setUnAllHouseholds')
      }
    }
  }
</script>

<style scoped lang="scss">
  .phone-option {
    margin-left: 32px;
    margin-top: -8px;
  }
  .the-item {
    margin-top: 16px;
  }
  .h3 {
    color: #333333;
    font-size: 1em;
    margin-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Geo/MGeoCount.vue